import { render, staticRenderFns } from "./MerchantRoleList.vue?vue&type=template&id=6e5917c2&scoped=true&"
import script from "./MerchantRoleList.vue?vue&type=script&lang=js&"
export * from "./MerchantRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5917c2",
  null
  
)

export default component.exports